/**
 * Converts an HH:MM formatted string representing a time of day
 * into a number that can be used for comparisons.
 */
export function timeStringToNumber(time: string) {
  return Number(time?.replace(':', ''));
}
